import React from 'react'
import IndustryEditor from 'sprockets_react/components/business/IndustryEditor'
import IndustryInput from 'sprockets_react/components/IndustryInput'

class IndustrySelector extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      suburb: '',
      selectedCategories: this.props.industry,
      disabled: props.disabled
    }

    this.handleSelectedTask = this.handleSelectedTask.bind(this)
    this.removeCategory = this.removeCategory.bind(this)
  }

  handleSelectedTask(event, response) {
    let selectedCategories = this.state.selectedCategories.slice()
    let categoryID = response.item.category_id
    let categoryName = response.item.category_name

    response.item.value = ""

    if (selectedCategories.find(category => category.id === categoryID) == null) {
      selectedCategories.push({ id: categoryID, name: categoryName })
      this.setState({ selectedCategories: selectedCategories })
    }
  }

  removeCategory(event) {
    let id = event.currentTarget.getAttribute("data-id")
    let selectedCategories = this.state.selectedCategories.slice()
    let index = selectedCategories.findIndex(category => category.id == id)

    selectedCategories.splice(index, 1)
    this.setState({ selectedCategories: selectedCategories })
  }

  render() {
    return (
      <div className="col-sm-12 p0">
        <div className="card card-flat mb16 mt24">
          <div className="card-content card-pad-lg">
            <div className="font-21 pb8 bold">
              Would you like to add other work that you do?
            </div>
            <div className="row">
              <div className="col-xs-12">
                <IndustryInput
                  handleSelectedItem={this.handleSelectedTask}
                  guId={SS.utils.generateGuid()}
                  disabled= { this.state.disabled ? "disabled" : ""}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="card card-flat">
          <div className="card-content card-pad-lg">
            <div id="industry-selection" className="form-group mb0">
              <div className="col-sm-12">
                <div className="has-feedback">
                  <label className="control-label font-14 pt0">
                    You work as a:
                  </label>

                  <div className="row">
                    <div className="col-xs-12">
                      <div id="business-categories">
                        { this.state.selectedCategories.map((sc, i) => {
                          return (
                            <IndustryEditor
                              removeCategory={this.removeCategory}
                              categoryID={sc.id}
                              categoryName={sc.name}
                              key={sc.id}
                              subcategoryIds={sc.subcategory_ids}
                              action={this.props.action || "create"}
                              handleUpdate={this.props.handleComponentUpdate}
                              jobFilterLocked={this.props.jobFilterLocked}
                            />
                          )
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default IndustrySelector
